export const publicEstimateRequestKeys = {
  request: (estimateId: string) => ['public-estimate-request', estimateId] as const,
}
